module.exports = __webpack_public_path__ + "static/img/components.b0e4b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontProJect/fangzhou/components.png
// module id = wZSC
// module chunks = 1